import { ContractLineValidator } from '@/services/validation/ContractLineValidator';

import { validationSchema } from './validationSchema';

export const validator = new ContractLineValidator<ContractLine>(validationSchema);